export enum SIZE {
  SMALL = 1,
  MEDIUM,
  LARGE,
}
